import { withCustomProductBarcodesHoc } from './HOCs/CustomProductBarcodesHoc';

export default {
    name: 'productBarcodeGridPage',
    before: [],
    after: [],
    setup: (app) => {
        const pageName = 'productDetailsBarCodes';
        const pageRoute = app.routes.getItem(pageName);
        if (pageRoute) {
            pageRoute.render = withCustomProductBarcodesHoc(app);
            app.routes.changeItem(pageName, pageRoute);
        }
    },
};
